import styled, { css } from 'styled-components';

import CoreCell from '../../../../NewTable/_common/CoreCell';
import * as styles from '../../styles';
import ControllerWrapper from '../ControllerWrapper/ControllerWrapper';
import { colorTokens } from '../../../../../tokens/globals/tokens';

const AppearanceWrapper = styled.div`
  align-items: baseline;
  /*
    This padding should be a token or a constant, as it's
    used in different places to get the alignment right
  */
  padding-top: 9px;
  display: inline-flex;
  width: ${props => styles.inputWidths[props.theme.controllerWidth] || styles.inputWidths.large};

  ${CoreCell} > ${ControllerWrapper} && {
    padding: 0;
    width: auto;
  }

  ${({ theme }) =>
    theme.controllerDisabled &&
    css`
      color: ${colorTokens.GlobalBrandGray50};
    `}

  ${({ theme }) =>
    theme.checkboxTrim &&
    css`
      padding-top: 0;
      width: auto;
    `}
`;

export default AppearanceWrapper;
